module.exports = __webpack_public_path__ + "static/media/no-video-available.4ed483fe.jpg";